/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import BaseSidebar from 'layout/sidebar';
import SidebarItem from 'layout/sidebar/item';
import { checkCurrentPath } from 'layout/utils';

/**
 * Style dependencies
 */
import './styles.scss';

const Sidebar = ({ path }) => {
    return (
        <BaseSidebar className='dashboard-sidebar'>
            <SidebarItem label='All Connections' path='/' selected={checkCurrentPath(['/', '/connections', '/sgc'], path)} />
            <SidebarItem label='Resources' path='/resources' selected={checkCurrentPath('/resources', path)} />
            <SidebarItem
                label='Account Settings'
                path='/settings/locations'
                selected={checkCurrentPath(['/settings', '/settings/locations', '/settings/data'], path)}
            />
        </BaseSidebar>
    );
};

export default Sidebar;
